<template>
  <div class="file-manager">
    <div class="d-flex flex-wrap align-items-center justify-content-between mb-2">
      <h4>مدیریت فایل</h4>
      <div class="d-flex flex-wrap">
<!--        <span class="mr-1" style="margin-top: 8px">فشرده شود</span>-->
<!--        <b-form-checkbox-->
<!--            v-model="CompressFile"-->
<!--            switch-->
<!--            inline-->
<!--            style="margin-top: 5px"-->
<!--        />-->
        <v-select
            v-model="params.Entity"
            v-b-tooltip.hover.top="'موجودیت'"
            :options="enums('entities')"
            :clearable="false"
            dir="rtl"
            label="text"
            placeholder="موجودیت"
            :reduce="x => x.value"
            class="select-size-sm"
            style="width: 150px;margin-left: 5px"
        />
        <v-select
            v-model="params.Order"
            v-b-tooltip.hover.top="'ترتیب براساس'"
            :options="enums('orderBy')"
            :clearable="false"
            dir="rtl"
            label="text"
            placeholder="ترتیب براساس"
            :reduce="x => x.value"
            class="select-size-sm"
            style="width: 150px;margin-left: 5px"
        />
        <v-select
            v-model="params.IsAscending"
            v-b-tooltip.hover.top="'ترتیب'"
            :options="enums('order')"
            :clearable="false"
            dir="rtl"
            label="text"
            placeholder="ترتیب"
            :reduce="x => x.value"
            class="select-size-sm"
            style="width: 150px"
        />
      </div>
    </div>
    <b-tabs
        v-model="tab"
        :nav-wrapper-class="!isMobile ? 'col-12 col-md-2 text-left' : ''"
        :vertical="!isMobile"
        pills
    >
      <b-tab
          v-for="type in enums('fileType')"
          :key="type.key"
          :title="type.text"
      >
        <b-card>
          <b-overlay v-if="isEntity" :show="loading" rounded="sm">
            <div class="fm-content row">
              <div class="fm-files col-md-8">
                <fm-upload-file v-if="editable" :entity="params.Entity" @update="getFiles" />
                <fm-file
                    v-for="(file, i) in files"
                    :key="i"
                    :file="file"
                    :editable="editable"
                    @click="viewFile(file)"
                    @delete="deleteFile(file)"
                    @dblclick.native="selectFile(file)"
                />
              </div>
              <div v-if="!loading" class="fm-view col-md-4" :class="isMobile && 'm-0 mt-2'">
                <fm-file-view
                    v-if="selectedFile"
                    :key="selectedFile.Id || selectedFile.Path || selectedFile.Name"
                    :file="selectedFile"
                    :editable="editable"
                    :selectable="selectable"
                    @delete="deleteFile(selectedFile)"
                    @select="selectFile(selectedFile)"
                />
                <div v-else class="h-100 d-flex align-items-center justify-content-center font-small-3 text-muted">اطلاعاتی وجود ندارد</div>
              </div>
            </div>
          </b-overlay>
          <div v-else class="text-center font-small-3 text-gray" style="color: #8d8d8d">
            <span>ابتدا از قسمت بالا موجودیت موردنظر را انتخاب نمایید</span>
          </div>
        </b-card>
      </b-tab>
    </b-tabs>
    <fm-delete-file
        :show.sync="showDeleteFileModal"
        @delete="submitDeleteFile(deletingFile)"
    />
  </div>
</template>

<script>
import Table from "@core/mixins/table";
import FmFile from "@/views/menu/file-manager/components/fmFile.vue";
import FmFilePreview from "@/views/menu/file-manager/components/fmFilePreview.vue";
import FmUploadFile from "@/views/menu/file-manager/components/fmUploadFile.vue";
import FmFileView from "@/views/menu/file-manager/components/fmFileView.vue";
import FmDeleteFile from "@/views/menu/file-manager/components/fmDeleteFile.vue";

export default {
  name: "FileManagerIndex",
  components: { FmDeleteFile, FmFileView, FmUploadFile, Table, FmFilePreview, FmFile },
  props: {
    entity: { type: [String, Number], default: null },
    selectable: { type: Boolean, default: true },
    editable: { type: Boolean, default: true },
    activeType: { type: String, default: 'all' },
  },
  data() {
    return {
      loading: false,
      tab: 0,
      screenWidth: 0,
      params: {
        Entity: '',
        Page: 1,
        Order: 2,
        IsAscending: false
      },
      files: [],
      selectedFile: null,
      deletingFile: null,
      showDeleteFileModal: false,
      CompressFile: false
    }
  },
  computed: {
    fileType() {
      return this.enums('fileType')[this.tab]
    },
    isEntity() {
      return this.params.Entity !== '' && this.params.Entity !== null
    },
    isMobile() {
      return this.screenWidth <= 768
    }
  },
  watch: {
    activeType: {
      immediate: true,
      handler(val) {
        const types = this.enums('fileType')
        const index = types.findIndex(item => item.key === val || item.value === val)
        this.tab = index !== -1 ? index : 0
      }
    },
    fileType: {
      immediate: true,
      handler: 'getFiles'
    },
    params: {
      deep: true,
      handler: 'getFiles'
    },
    entity: {
      immediate: true,
      handler(val) {
        this.params.Entity = val
      }
    }
  },
  mounted() {
    this.updateScreenWidth()
    this.onScreenResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.updateScreenWidth()
    })
  },
  methods: {
    getFiles() {
      if (this.params.Entity === '') return
      let data = {
        ...this.params,
        ...(this.fileType.key !== 'all') && { Type: this.fileType.value }
      }
      this.loading = true
      this.$http.post(this.$api.fileManager.getList, data)
        .then(res => {
          this.files = res.data
        }).catch(() => {
          this.files = []
        }).finally(() => {
          this.loading = false
        this.selectedFile = null
        })
    },
    viewFile(file) {
      this.selectedFile = file
    },
    selectFile(file) {
      if (!this.selectable) return
      if (file) this.$emit('select', file)
    },
    deleteFile(file) {
      this.showDeleteFileModal = true
      this.deletingFile = file
    },
    submitDeleteFile(file) {
      if (!file) return
      let data = { path: file.Path }
      this.loading = true
      this.$http.post(this.$api.fileManager.remove, data).then(() => {
        this.loading = false
        let index = this.files.findIndex(item => item.Name === file.Name)
        if (index !== -1) this.files.splice(index, 1)
        this.selectedFile = null
      }).finally(() => {
        this.loading = false
      })
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth
    },
    onScreenResize() {
      window.addEventListener('resize', () => {
        this.updateScreenWidth()
      })
    }
  }
}
</script>

<style lang="scss">
.font-sans {
  font-family: sans-serif;
}
.file-manager {
  .nav-pills .nav-link {
    justify-content: start;
  }
  .row {
    flex-wrap: nowrap;
  }
  .fm-content {
    //grid-template-columns: repeat(3, 1fr);
    .fm-files {
      //grid-column: 1 / 3;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
    }
    .fm-view {
      //grid-column: 3 / 4;
      background-color: #f6f6f6;
      padding: 15px;
      margin: -21px -21px -21px 0;
      .fm-view-img {
        min-height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
      }
      .fm-view-content {
        background-color: white;
        padding: 15px 20px;
        border-radius: 15px;
      }
    }
  }
}
</style>